<template>

    <div class="c-form_videos">
        <form-input
            v-model="newVideo"
            label="Wklej link do filmów z serwisu YouTube, które chcesz udostępnić Pacjentowi"
            btn="green"
            btn-label="Dodaj"
            @click="addVideo"
            v-validate="'youtube_url'">
        </form-input>

        <ul class="c-form_videos__list">
            <form-video
                v-for="(video, index) in value"
                :key="index"
                :url="video"
                canDelete
                @delete="removeVideo(video)"
                class="c-form_videos__video">
            </form-video>
        </ul>
    </div>

</template>


<script>

import FormInput from './FormInput'
import FormVideo from './FormVideo'

export default {

    name: 'FormVideos',

    props: {
        value: Array
    },

    data() {
        return {
            newVideo: ''
        }
    },

    methods: {
        parseVideoId(url) {
            var match = url.match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/)
            return (match && match[1].length) === 11 ? match[1] : false
        },
        addVideo() {
            var videoId = this.parseVideoId(this.newVideo.trim())
            if (this.parseVideoId(this.newVideo) !== false) {
                this.value.push(this.newVideo.trim())
                this.newVideo = ''
            }
        },
        removeVideo(video) {
            const index = this.value.indexOf(video)
            if (index >= 0)
                this.value.splice(index, 1)
        }
    },

    components: {
        FormInput,
        FormVideo
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';



</style>
